import index from '../api/index'

export const Get = () => {
    return new Promise((resolve) => {
        resolve(index.basePrice.Get())
    })
}